export const BREAKDOWN_LOCATION_OPTIONS = () => ({
  AT_HOME_IN_DRIVEWAY: $localize`At Home / In Driveway`,
  IN_PARKING_GARAGE: $localize`In a Parking Garage`,
  IN_PARKING_LOT: $localize`In a Parking Lot`,
  ON_SIDE_ROAD: $localize`On the Side of Road`,
  ON_INTERSTATE_HIGHWAY: $localize`On the Interstate / Highway`,
})
